export enum CertificationPlanScopeType {
  AllScopes = 0,
  Application = 1,
  General = 2,
  Product = 3,
  Process = 4,
  HealthAndSafety = 5,
  Sustainability = 6,
}